<template>
    <div class="paged-quotes">
        <div class="container">
            <div class="row paged-quotes__controls">
                <div class="col-6-sm">
                    <div v-if="prevVisible" v-on:click="prevHandler()" class="paged-quotes__nav-btn">
                        <span class="fa fa-arrow-left"></span> terug
                    </div>
                </div>
                <div class="col-6-sm">
                    <div v-if="nextVisible" v-on:click="nextHandler()" class="paged-quotes__nav-btn">
                         verder <span class="fa fa-arrow-right"></span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12-sm">
                    <div class="paged-quotes__item quote" v-for="quote in currentQuotes">
                        {{quote.quote}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .paged-quotes__controls
        margin-top 2em
        margin-bottom 2em

    .paged-quotes__item
        margin-bottom 4em

    .paged-quotes__nav-btn
        cursor pointer
        font-size .9em
        font-family $font-button

</style>
<script>
    export default{
        props: {
            quotes: {
                type: Array,
                default: []
            }
        },
        watch: {
            quotes() {
                this.currentIndex = 0;
            }
        },
        created() {
            this.pageSize = 2;
        },
        computed: {
            currentQuotes() {
                const start = this.currentIndex * this.pageSize;
                return this.quotes.slice(start, start + this.pageSize);
            },
            nextVisible() {
                return (this.currentIndex + 1) * this.pageSize < this.quotes.length;
            },
            prevVisible() {
                return this.currentIndex > 0;
            }
        },
        data() {
            return {
                currentIndex: 0
            }
        },
        methods: {
            prevHandler() {
                this.currentIndex--;
            },
            nextHandler() {
                this.currentIndex++;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// paged-quotes.vue?a34ff74a